export enum EDeviceStatus {
  ON = "ON",
  OFF = "OFF",
  BOTH = "BOTH",
}
